import { OAUTH_FAILURE_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import modalFailureImg from 'root/src/client/public/failureModalImg.png'

export default {
	[OAUTH_FAILURE_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'failureModal',
		pageContent: {
			modalSize: 'medium',
			imgSrc: modalFailureImg.src,
			title: 'Oops!',
			errorText: 'Something went wrong',
			infoText: `Something broke!
			Give it another shot, or contact us for help at support@daredrop.com`,
			buttonLabel: 'CONTINUE',
		},
	},
}
